import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Alert,
  Snackbar,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { useReactHookForm } from '../../../hooks/useReactHookForm';
import { useSaveData, useSaveDataForFastField, useSaveDataForFastFieldRecall } from '../../../hooks/useSaveData';
import { ReactHookForm } from '../../../components/hook-form/react-hook-form.component';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { DateFormat, FormDateField } from '../../../components/hook-form/form-date.field.component';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { SelectInspector } from './select-inspector.component';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { FormInputTime } from '../../../components/hook-form/form-input.time.component';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';
import dayjs from 'dayjs';

interface SaveDataDialogProps {
  workOrder: any;
  onClose: () => void;
  onSaveCompleted?: (data: any) => void;
}

const today = dayjs().startOf('day');

// Create a new date for yesterday by subtracting one day (24 hours)

const shedulingSchema = Yup.object().shape({
  scheduledDate: Yup.date()
    .nullable()
    .typeError('Please enter a valid date') // Ensures the date is valid
    .min(today, 'Scheduled date must be in the future'),
});

const isDUXEnabled = process.env.REACT_APP_DUX_FLAG === 'true';

export const ScheduleDialog = ({ workOrder, onClose, onSaveCompleted }: SaveDataDialogProps) => {
  const form = useReactHookForm({
    defaultValues: {
      ...workOrder,
    },
    yupSchema: shedulingSchema,
  });

  const [scheduleRule, setScheduleDialogRule] = useState([]);
  const [pendingWorkOrder, setPendingWorkOrder] = useState([]);
  const [cutOffTimeCondition, setCutOffTimeCondition] = useState<boolean>(false);

  const { isLoading: sheduleRuleLoading, mutateAsync: sheduleRuleCheck } = useSaveData<any>(
    workOrdersApiKeyStore.validateWorkOrderSheduleRules()
  );

  const ishavePermission = useAuthorize([UserPermissionName?.OVERRIDE]);
  const { isLoading, mutateAsync } = useSaveData(workOrdersApiKeyStore.scheduleWorkOrder());
  const { isLoading: isLoadingFastfieldDispatch, mutateAsync: fastfieldDispatch } = useSaveDataForFastField(
    workOrdersApiKeyStore.fastFieldDispatch(workOrder?.workOrderID, 'single')
  );
  // const { isLoading: isLoadingFastfieldRecall, mutateAsync: fastfieldRecall } = useSaveDataForFastFieldRecall(
  //   workOrdersApiKeyStore.fastFieldRecall(workOrder?.workOrderID)
  // );
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (workOrder?.workOrderStatus === 'Ready' && workOrder?.proposedScheduledDate) {
      // if (workOrder?.showScheduleDateRange) {
      //   form.setValue('scheduledFromDate', workOrder?.proposedScheduledDate);
      // } else {
      form.setValue('scheduledDate', workOrder?.proposedScheduledDate);
      //}
    }
  }, [workOrder]);

  const closeDialogHandler = () => {
    form.reset();
    onClose();
  };

  const submitHanlder = async (data: any) => {
    const scheduledTime = dayjs(data.scheduledTime, 'hh:mm A');
    const cutOffTime = !workOrder.cutOffTime ? null : dayjs(workOrder.cutOffTime, 'hh:mm A');
    const currentTime = dayjs(); // Current date and time
    // const cutOffTime = workOrder.cutOffTime ? dayjs(workOrder.cutOffTime, "hh:mm A").subtract(1, 'hour') : null;

    const rulePayload = {
      schedulingFrom: "schedulepopup",
      workOrderInfos: [
        {
          workOrderID: data?.workOrderID,
          workOrderNumber: data?.workOrderNumber,
          scheduledDate: dayjs(data?.scheduledDate)?.format('MM/DD/YYYY'),
        }
      ]
    }

    if (!data?.inspectorID) {
      setOpen(true);
      setMessage('Please Select inspector');
      return;
    }
    // else if (
    //   data?.scheduledTime === 'Invalid Date' &&
    //   data?.scheduledMeridiem === 'Appt.' &&
    //   data?.showScheduleDateRange
    // ) {
    //   setOpen(true);
    //   setMessage('Invalid Time');
    // }
    //else if (!data.scheduledDate && !watchValue?.showScheduleDateRange) {
    if (!data.scheduledDate) {
      setOpen(true);
      setMessage('Please enter scheduled date');
      return;
    }
    //else if (!data?.scheduledTime && data?.scheduledMeridiem === 'Appt.' && !data?.showScheduleDateRange) {
    if (!data?.scheduledTime && data?.scheduledMeridiem === 'Appt.') {
      setOpen(true);
      setMessage('Please enter scheduled time');
      return;
    }
    // else if (data?.showScheduleDateRange && !data?.scheduledFromDate) {
    //   setOpen(true);
    //   setMessage('Please enter scheduled from date');
    // }
    // else if (data?.showScheduleDateRange && !data?.scheduledToDate) {
    //   setOpen(true);
    //   setMessage('Please enter scheduled to date');
    // }
    //  else if (data?.showScheduleDateRange && !data?.invoiceTerm) {
    if (data?.isHourlyorTimeMaterialService && !data?.invoiceTerm) {
      setOpen(true);
      setMessage('Please select invoice term');
      return;
    }
    if (
      dayjs(data.scheduledDate).isSame(dayjs(), 'day') &&
      data.scheduledMeridiem === 'Appt.' && // Check if scheduledDate is today
      scheduledTime.isBefore(currentTime) // Check if scheduledTime is not in the past
    ) {
      setOpen(true);
      setMessage('Scheduled time must be in the future');
      return;
    }

    const ruleResponse: any = await sheduleRuleCheck({ data: rulePayload });

    // New conditions for cutoff time check
    if (
      cutOffTime &&
      dayjs(data.scheduledDate).isSame(dayjs(), 'day') &&
      data.scheduledMeridiem === 'Appt.' &&
      cutOffTime.isBefore(scheduledTime)
    ) {

      if (ruleResponse?.data[0]?.pendingRules?.length > 0) {
        setScheduleDialogRule(ruleResponse?.data[0]?.pendingRules || []);
        setPendingWorkOrder(ruleResponse?.data[0]?.preReqWorkOrders || []);
      }
      setCutOffTimeCondition(
        !!(
          cutOffTime &&
          dayjs(data.scheduledDate).isSame(dayjs(), 'day') &&
          data.scheduledMeridiem === 'Appt.' &&
          cutOffTime.isBefore(scheduledTime)
        )
      );
      handleOpenDialog();
    } else if (cutOffTime && dayjs(data.scheduledDate).isSame(dayjs(), 'day') && cutOffTime.isBefore(dayjs())) {
      if (ruleResponse?.data[0]?.pendingRules?.length > 0) {
        setScheduleDialogRule(ruleResponse?.data[0]?.pendingRules || []);
        setPendingWorkOrder(ruleResponse?.data[0]?.preReqWorkOrders || []);
      }
      setCutOffTimeCondition(!!(cutOffTime && dayjs(data.scheduledDate).isSame(dayjs(), 'day') && cutOffTime.isBefore(dayjs())));
      handleOpenDialog();
    }
    else if (ruleResponse?.data[0]?.pendingRules?.length > 0) {
      setScheduleDialogRule(ruleResponse?.data[0]?.pendingRules || []);
      setPendingWorkOrder(ruleResponse?.data[0]?.preReqWorkOrders || []);
      handleOpenDialog();
    }
    else {
      const updatedData = { ...data, scheduledDate: dayjs(data?.scheduledDate).format('MM/DD/YYYY') };
      const result = await mutateAsync({ data: updatedData });

      onSaveCompleted?.(result.data);
      closeDialogHandler();
    }
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    // setMessage({ severity: 'success', messageInfo: '' });
    setOpen(false);
    setMessage('');
  };

  const watchValue = form.watch();

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const closeDialog = () => {
    setOpenDialog(false);
    setScheduleDialogRule([]);
    setPendingWorkOrder([]);
    setCutOffTimeCondition(false);
  };

  const handleSumbitConfirm = async () => {
    const result = await mutateAsync({ data: watchValue });
    onSaveCompleted?.(result.data);
    closeDialogHandler();
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Dialog
      open={true}
      maxWidth={'lg'}
      // onClose={closeDialogHandler}
      PaperProps={{
        sx: {
          maxWidth: '1480px', // Set your custom max-width
          width: '100%', // Ensure proper responsive behavior
        },
      }}
    >
      <DialogTitle id="form-dialog-title">SCHEDULE</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={closeDialogHandler}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>

      <ReactHookForm formName="SCHEDULE_FORM" onSubmit={submitHanlder} formContextProps={form}>
        <DialogContent dividers className="popupDilog">
          <LoadingIndicator isLoading={isLoading} />

          <SelectInspector />
        </DialogContent>
        <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
          <DialogActions className="spaceBetween">
            <Button variant="outlined" style={{ width: '130px' }} onClick={closeDialogHandler}>
              Cancel
            </Button>
            <Grid container style={{ gap: '5px', justifyContent: 'flex-end' }}>
              <Grid item lg={1.5} sm={1.5} xl={1.5} xs={1.5} style={{ marginLeft: 'auto' }}>
                <FormInput disabled label="Work Order#" name="workOrderNumber" />
              </Grid>
              {/* {!watchValue?.showScheduleDateRange && ( */}
              <>
                {workOrder?.inspectionRequestType === 'RescheduleRequest' && isDUXEnabled && (
                  <Grid item lg={2.5} sm={2.5} xl={2.5} xs={2.5}>
                    <FormDateField
                      label="Requested Reschedule Date"
                      name="proposedScheduledDate"
                      format={DateFormat.SIMPLE_DATE}
                    />
                  </Grid>
                )}
                <Grid item lg={1.7} sm={1.7} xl={1.7} xs={1.7}>
                  <FormDateField label="Scheduled Date" name="scheduledDate" format={DateFormat.SIMPLE_DATE} />
                </Grid>
                <Grid item lg={1} sm={1} xl={1} xs={1}>
                  <FormSelect
                    label="Time"
                    name="scheduledMeridiem"
                    options={[
                      { value: 'N/A', label: 'N/A', isDefault: true },
                      { value: 'AM', label: 'AM' },
                      { value: 'PM', label: 'PM' },
                      { value: 'Appt.', label: 'Appt.' },
                    ]}
                  />
                </Grid>
                {watchValue.scheduledMeridiem === 'Appt.' && (
                  <Grid item lg={2} sm={2} xl={2} xs={2}>
                    <FormInputTime name="scheduledTime" label="Scheduled Time" />
                  </Grid>
                )}
              </>
              {/* )} */}
              {watchValue?.showScheduleDateRange && (
                <>
                  <Grid item lg={1.5} sm={1} xl={1.5} xs={1}>
                    <FormSelect
                      label="Invoice Term"
                      name="invoiceTerm"
                      options={[
                        { value: 'endofmonth', label: 'End of Month' },
                        { value: 'projectcompletion', label: 'Project Completion' },
                        { value: 'lotcompletion', label: 'Lot/Unit Completion' },
                      ]}
                    />
                  </Grid>
                </>
              )}
              {/* enable the following options based on the property 'showScheduleDateRange' */}
              {/* {watchValue?.showScheduleDateRange && (
                <>
                  <Grid item lg={2} sm={2} xl={2} xs={4}>
                    <FormDateField label="Scheduled From" name="scheduledFromDate" format={DateFormat.SIMPLE_DATE} />
                  </Grid>
                  <Grid item lg={2} sm={2} xl={2} xs={4}>
                    <FormDateField
                      label="Scheduled To"
                      name="scheduledToDate"
                      dateLimits={{ minDateEnabled: true, minDateValue: 'scheduledFromDate' }}
                      format={DateFormat.SIMPLE_DATE}
                    />
                  </Grid>
                  <Grid item lg={1.5} sm={1} xl={1.5} xs={1}>
                    <FormSelect
                      label="Invoice Term"
                      name="invoiceTerm"
                      options={[
                        { value: 'endofmonth', label: 'End of Month' },
                        { value: 'projectcompletion', label: 'Project Completion' },
                        { value: 'lotcompletion', label: 'Lot/Unit Completion' },
                      ]}
                    />
                  </Grid>
                </>
              )} */}
              <div>
                <Button
                  type="button"
                  disabled={isLoading || isReadOnlyPermission || sheduleRuleLoading}
                  variant="contained"
                  style={{ width: '100px' }}
                  className="btn btn-sm btn-primary btn-form-regular"
                  onClick={() => form.handleSubmit(submitHanlder)()}
                >
                  SCHEDULE
                </Button>
              </div>
            </Grid>
            <Snackbar
              open={open}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              onClose={handleClose}
            >
              <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={handleClose}>
                {message}
              </Alert>
            </Snackbar>
          </DialogActions>
        </div>
        <>
          {openDialog && (
            <Dialog
              open={openDialog}
              className="modalpopup"
              title={'CONFIRM STATUS'}
            // onClose={closeDialog}
            >

              <div>
                <div style={{ padding: '25px 50px' }}>
                  <div>
                    <h4>Please see the below validations</h4>
                    <br></br>
                    <ul>{scheduleRule?.map((data: any) => <li key={data}>{data}</li>)}
                      {pendingWorkOrder?.length > 0 && (
                        <dl>
                          <dt>Pending Work Orders:</dt>
                          {pendingWorkOrder?.map((data: any) => <dd key={data}>- {data}</dd>)}
                        </dl>
                      )}
                      {cutOffTimeCondition &&
                        <li>{ishavePermission ? "The schedule time is greater than cut off time. Are you sure you want to continue?" :
                          "The schedule time is greater than cut off time. You do not have permission to schedule."}</li>
                      }
                    </ul>
                  </div>
                  <br></br>
                  <div>
                    {ishavePermission ? (
                      <h5>
                        You have the permission to schedule without completing the validations. Are you sure you want to
                        continue?
                      </h5>
                    ) : (
                      <h5>You can not schedule without completing the validations.</h5>
                    )}
                  </div>
                  <LoadingIndicator isLoading={isLoading} />
                </div>
              </div>
              {/* <div>
                <div style={{ padding: '25px 50px' }}>
                  <div>
                    {ishavePermission
                      ? 'The schedule time is greater than cut off time. Are you sure you want to continue?'
                      : 'The schedule time is greater than cut off time. You do not have permission to schedule.'}
                  </div>
                  <LoadingIndicator isLoading={isLoading} />
                </div>
              </div> */}
              <DialogActionsBar>
                <div className=" spaceBetween">
                  <button
                    style={{ cursor: 'pointer' }}
                    className="btn btn-sm btn-default btn-lightGrey"
                    onClick={closeDialog}
                    autoFocus
                  >
                    Cancel
                  </button>
                  {ishavePermission && (
                    <button
                      className="btn btn-sm btn-primary btn-delete"
                      style={{
                        backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                        color: isReadOnlyPermission ? 'black' : '#fff',
                        cursor: 'pointer'
                      }}
                      type="button"
                      onClick={handleSumbitConfirm}
                      disabled={isLoading || isReadOnlyPermission}
                    >
                      Confirm
                    </button>
                  )}
                </div>
              </DialogActionsBar>
            </Dialog>
          )}
        </>
      </ReactHookForm>
    </Dialog>
  );
};
